const XLSX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const sanitizeFilename = (filename, fallbackFilename) => {
  const safeFilename = filename
    ?.replace(/^UTF-8''/i, "")
    .replace(/[\\/:*?"<>|]/g, "-")
    .trim();

  return safeFilename || fallbackFilename;
};

export const getFilenameFromDisposition = (contentDisposition, fallbackFilename) => {
  if (!contentDisposition) return fallbackFilename;

  const utf8Match = contentDisposition.match(/filename\*=([^;]+)/i);
  const plainMatch = contentDisposition.match(/filename=(?:"([^"]+)"|([^;]+))/i);
  const encodedFilename = utf8Match?.[1] || plainMatch?.[1] || plainMatch?.[2];

  if (!encodedFilename) return fallbackFilename;

  const withoutQuotes = encodedFilename.trim().replace(/^['"]|['"]$/g, "");
  let decodedFilename = withoutQuotes;

  try {
    decodedFilename = decodeURIComponent(withoutQuotes.replace(/^UTF-8''/i, ""));
  } catch (error) {
    decodedFilename = withoutQuotes;
  }

  return sanitizeFilename(decodedFilename, fallbackFilename);
};

export const downloadExcelResponse = (response, fallbackFilename) => {
  const filename = getFilenameFromDisposition(
    response?.headers?.["content-disposition"],
    fallbackFilename
  );
  const blob = response?.data instanceof Blob
    ? response.data
    : new Blob([response?.data], { type: XLSX_MIME_TYPE });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = objectUrl;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);

  return filename;
};

const readBlobText = (blob) => {
  if (typeof blob?.text === "function") return blob.text();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

export const getExcelExportErrorMessage = async (error, fallbackMessage) => {
  const responseData = error?.response?.data;

  if (responseData instanceof Blob) {
    try {
      const body = JSON.parse(await readBlobText(responseData));
      return body?.message || fallbackMessage;
    } catch (parseError) {
      return fallbackMessage;
    }
  }

  return responseData?.message || error?.message || fallbackMessage;
};
